import { Injectable } from '@angular/core';
import { AuthorizationService } from './authorization.service';

@Injectable()
export class IdentityService {
	// Adds some minor functionality to the AdalService
	constructor(private authService: AuthorizationService) { }

	public getRoles(): string[] {
		if (this.authService.authenticated()) {

			return this.authService.getRoles();
		} else {
			return [''];
		}
	}

	public isInRole(neededRole: string): boolean {
		return this.getRoles().includes(neededRole);
	}
}